<template>
  <base-dialog
    :action="onAction"
    :action-name="'Add tax rate'"
    :close="onClose"
    :title="'Add tax rate'"
  >
    <template #activator="{ on }">
      <slot
        name="activator"
        v-bind="{ on }"
      />
    </template>

    <template #content>
      <v-container>
        <v-row>
          <v-col cols="12">
            <v-text-field
              outlined
              dense
              v-model="model.display_name"
              label="Display name"
              placeholder="ex. Sales tax, GST, VAT...etc"
              hide-details
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-text-field
              outlined
              dense
              v-model="model.jurisdiction"
              label="Region"
              persistent-hint
              hint="Region, or jurisdiction, is the area where the tax rate applies
                    (such as a city or country). It is useful for tax remittance"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <v-text-field
              outlined
              dense
              v-model="model.percentage"
              label="Rate"
              suffix="%"
              hide-details
            />
          </v-col>
          <v-col cols="6">
            <v-select
              outlined
              dense
              v-model="model.inclusive"
              :items="inclusionValues"
              item-value="id"
              item-text="name"
              hide-details
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-text-field
              outlined
              dense
              v-model="model.description"
              label="Description"
              persistent-hint
              hint="This description is for internal use only and will not be visible to your customers"
            />
          </v-col>
        </v-row>
      </v-container>
    </template>
  </base-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import BaseDialog from "../Common/BaseDialog"
import { isErrorResponse } from "../../services/util.service"

export default {
  components: { BaseDialog },
  data() {
    return {
      inclusionValues: [
        {
          id: true,
          name: 'Inclusive'
        },
        {
          id: false,
          name: 'Exclusive'
        },
      ],
      // modeled for stripes API
      initModel: {
        display_name: undefined,
        jurisdiction: undefined,
        percentage: 0.0,
        inclusive: false,
        description: undefined
      },
      model: {
        display_name: undefined,
        jurisdiction: undefined,
        percentage: 0.0,
        inclusive: false,
        description: undefined
      }
    }
  },
  methods: {
    ...mapActions([ 'createTaxRate' ]),
    resetModel() {
      this.model = { ...this.initModel }
    },
    onClose() {
      this.$emit('close')
    },
    onAction() {
      const payload = {
        ...this.model,
        percentage: parseFloat(this.model.percentage)
      }

      return this.createTaxRate(payload)
        .then(res => {
          if (!isErrorResponse(res)) {
            this.resetModel()
            this.$emit('action', payload)
          }
          return res
        })
    }
  }
}
</script>
